import React from 'react'
import {Price, Total, AddPretnRow, Cgst, Igst, Sgst} from './rowelements/others'
import BatchElement from './rowelements/batchelement'
import NameElement from './rowelements/nameelement'
import SupplierElement from './rowelements/supplierelement'
import OutState from './rowelements/outstate'
import PretnTotal from './rowelements/pretntotal'
import PurchaseBasicRate from './rowelements/purchasebasicrate'
import PretnDate from './rowelements/pretndate'
import QuantityElement from './rowelements/quantity'
import Discount from './rowelements/discount'
import {Loader} from '../../utils/misc'

import {Link } from 'react-router-dom'
import {getToken} from '../../storage'
import {NotificationManager} from 'react-notifications'
import {API_BASE_URL} from '../../constants'
import {basicRate, calculatePurchasePrice, calculateDiscount} from '../../utils/calculator'
import axios from 'axios'


class ResponsiveRow extends React.Component {

  render() {
      let item = this.props.item
      let pretn = this.props.pretn
      let td_gst
      if(pretn.is_igst) {
        td_gst = <div className="row">
            <div className="col-xs-12">
              <label className="hidden-md hidden-lg mtop">IGST</label>
               <Igst item={item}  />
            </div>
        </div>
      }
      else {
        td_gst = <div className="row">
              <div className="col-xs-6">
                <label className="hidden-md hidden-lg mtop">CGST</label>
                 <Cgst item={item}  />
              </div>
              <div className="col-xs-6">
                <label className="hidden-md hidden-lg mtop">SGST</label>
                 <Sgst item={item}  />
              </div>
            </div>
      }

      let batchelement

      if(typeof item !== undefined && item !== null && typeof item.item !== "undefined") {
        batchelement = <BatchElement item={item} onChangeCallback={this.props.handleUpdateItem}/>
      }
      else {
        batchelement = "No item selected"
      }

      return <div className="responsive-row">
        <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-3">
                <label className="hidden-md hidden-lg mtop">Name</label>
                <NameElement item={item} onAddCallback={this.props.handleUpdateItem} />
              </div>
              <div className="col-xs-6 col-sm-2 col-md-1">
                <label className="hidden-md hidden-lg mtop">Batch</label>
                {batchelement}
              </div>
              <div className="col-xs-6 col-sm-2 col-md-1">
                <label className="hidden-md hidden-lg mtop">Quantity</label>
                <QuantityElement item={item} onChangeCallback={this.props.handleUpdateQuantity} />
              </div>
              <div className="col-xs-6 col-sm-2 col-md-1">
                <label className="hidden-md hidden-lg mtop">Unit Rate</label>
                <PurchaseBasicRate item={item} onChangeCallback={this.props.handleUpdateBasicRate} />
              </div>

              <div className="col-xs-6 col-sm-2 col-md-1">
                <label className="hidden-md hidden-lg mtop">Discout</label>
                <Discount item={item} onChangeCallback={this.props.handleUpdateQuantity} />
              </div>
              <div className="col-xs-6 col-sm-2 col-md-1">
                <label className="hidden-md hidden-lg mtop">Taxable Price</label>
                <Price item={item}  />
              </div>

              <div className="col-xs-6 col-sm-4 col-md-2">
                {td_gst}
              </div>
              <div className="col-xs-6 col-sm-4 col-md-1">
                <label className="hidden-md hidden-lg mtop">Total</label>
                <Total item={item} />
              </div>
              <div className="col-xs-6 col-sm-4 col-md-1 mtop">
                <button className="btn btn-danger btn-xs" onClick={(e)=>{this.props.deleteRow(item.tableIndex)} } >Delete</button>
              </div>


        </div>
      </div>



  }
}

class ResonsiveHeader extends React.Component {
  render() {
    let pretn = this.props.pretn

    let igst_header
    if(pretn.is_igst) {
      igst_header = <div className="row"><div className="col-xs-12">IGST</div></div>

    }
    else {
      igst_header = <div className="row"><div className="col-xs-6">CGST</div><div className="col-xs-6">SGST</div></div>
    }

    return <div className="responsive-header hidden-xs hidden-sm"><div className="row">
          <div className="col-xs-12 col-sm-6 col-md-3">
            Name
          </div>
          <div className="col-xs-6 col-sm-2 col-md-1">
            Batch
          </div>
          <div className="col-xs-6 col-sm-2 col-md-1">
            Quantity
          </div>
          <div className="col-xs-6 col-sm-2 col-md-1">
            Unit Rate
          </div>

          <div className="col-xs-6 col-sm-2 col-md-1">
            Discount
          </div>
          <div className="col-xs-4 col-sm-2 col-md-1">
            Taxable Price
          </div>

          <div className="col-xs-4 col-sm-4 col-md-2">
            {igst_header}
          </div>
          <div className="col-xs-4 col-sm-4 col-md-1">
            Total
          </div>
          <div className="col-xs-6 col-sm-4 col-md-1">
          </div>
    </div></div>

  }
}

export default class Pretn extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      loading:true,
      pretn: {

      }
    }
    this.handleSupplierChange = this.handleSupplierChange.bind(this)
    this.handleDateChange= this.handleDateChange.bind(this)
    this.handleOutStateChange = this.handleOutStateChange.bind(this)
    this.handleUpdateItem = this.handleUpdateItem.bind(this)
    this.modifyItemState = this.modifyItemState.bind(this)
    this.handleAddItem = this.handleAddItem.bind(this)
    this.handleDeleteItem = this.handleDeleteItem.bind(this)
    this.handleAddRow = this.handleAddRow.bind(this)
    this.handleCalculateTotal = this.handleCalculateTotal.bind(this)
    this.handleUpdateQuantity = this.handleUpdateQuantity.bind(this)
    this.handleUpdateBasicRate = this.handleUpdateBasicRate.bind(this)
    this.handleUpdatePurchasePrice = this.handleUpdatePurchasePrice.bind(this)
    this.handleSupplierBillChange = this.handleSupplierBillChange.bind(this)
    this.getDiscount = this.getDiscount.bind(this)
    this.deletePretn = this.deletePretn.bind(this)
    this.submit = this.submit.bind(this)
  }

  handleUpdateBasicRate(item) {
    // calculate purchase price
    var b = item['purchase_basic_rate']
    if (isNaN(b)) {
      b = 0
    }

    if(typeof item.gst !== "undefined" && item.gst !== null) {
          let gst_pct = parseFloat(item.gst.igst)
          item['purchase_rate'] = calculatePurchasePrice(b, gst_pct)
    }
    this.handleUpdateQuantity(item)


  }
  handleSupplierBillChange(e) {
    this.modifyItemState('supplier_bill_no', e.target.value)
  }


  handleUpdatePurchasePrice(item) {
    // calculate basic rate
    var s = item['purchase_rate']
    if (isNaN(s)) {
      s = 0
    }
    else {

      if(typeof item.gst !== "undefined" && item.gst !== null) {

          let gst_pct = 0
          if(item.gst.type === "C") {
            gst_pct = item.gst.cgst + item.gst.sgst

          }
          else {
            gst_pct = item.gst.igst
          }
            item['purchase_basic_rate'] = basicRate(s, gst_pct)

            this.handleUpdateQuantity(item)
      }
    }
  }

  componentDidMount() {

    let params = this.props.match.params
    if(typeof params.pretn_id !== "undefined") {
      this.setState({mode:'edit'})
      document.title = "Edit Debit Note " + this.props.match.params.pretn_id
      this.getPretn(this.props.match.params.pretn_id).then((response)=>{
        if(response.status===200) {
          console.log(response.data.pretn);
          this.setState({pretn: response.data.pretn, loading:false, pretn_item_tableindex: response.data.pretn.pretnitem_set.length})

        }
      }).catch((err)=>{
        this.setState({loading:false})
      })
    }
    else {
        document.title = "Create New Debit Note "
        this.setState({loading:false})
        this.handleAddRow()
    }

  }

  getPretn(pretn_id) {
    return axios({
      url: '/get_pretn/?serial='+pretn_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  getDiscount(item) {

    // calculate discount
    let quantity = parseFloat(item.quantity)
    if(quantity <= 0) {
      item['discount_value'] = 0
    }
    else if( typeof item['discount_edited'] !== "undefined" ) {
      item['discount_value'] = item['discount_edited']
    }
    else {
      let discount_set = item.discount_set
      let matchingDiscount
      if(typeof discount_set !== "undefined" && discount_set !== null) {

        // sort discount set with respect to quantity
        discount_set = discount_set.sort((a,b)=>{
          return b.quantity - a.quantity
        })

        for(var i=0; i<discount_set.length; i++) {
          let d = discount_set[i]
          if(quantity >= d.quantity) {
            matchingDiscount = d
            break;
          }
        }

        if(typeof matchingDiscount !== "undefined") {
            // if discount defined in percentage
            if(matchingDiscount.is_percentage) {
              item['discount_value'] = calculateDiscount(item.price, matchingDiscount.rate)
            }
            else {
              item['discount_value'] = matchingDiscount.value
            }
        }
        else {
              item['discount_value'] = 0
        }

    }
    else {
      item['discount_value'] = 0
    }
  }
}

handleUpdateQuantity(item) {

  // calculate price, cgst, sgst, igst, total
  let gst = item.gst

  var b = parseFloat(item.purchase_basic_rate), q = parseFloat(item.quantity)
  if (isNaN(b)) {
    b = 0
  }
  if (isNaN(q)) {
    q = Number(0)
  }
  console.log(b, q);
  item['price']  = parseFloat(parseFloat(b * q).toFixed(2))
  this.getDiscount(item)
  let afterDiscount = item['price']
  if(!isNaN(item['discount_value'])) {
      afterDiscount = item['price'] - parseFloat(item['discount_value'])
  }
  else {
    // not a number
    item['discount_value'] = Number(0)
  }

  item['price'] = parseFloat(afterDiscount).toFixed(2)
  if(afterDiscount <=0) {
    afterDiscount = 0
  }


  if(typeof gst !== "undefined" && gst !== null && gst.type !== "undefined" && gst.type !== null) {
      item['cgst_amount'] = parseFloat( parseFloat(afterDiscount*gst.cgst/100).toFixed(2) )
      item['sgst_amount'] = parseFloat( parseFloat(afterDiscount*gst.sgst/100).toFixed(2) )
      item['igst_amount'] = parseFloat( parseFloat(afterDiscount*gst.igst/100).toFixed(2) )
  }


  item['total'] = parseFloat(parseFloat(afterDiscount +item['igst_amount']).toFixed(2))

  this.handleUpdateItem(item)
}

  handleCalculateTotal(pretn_pretnitem_set) {

    let total = 0, totalPrice=0, totalTax=0, totalDiscount=0
      if(typeof pretn_pretnitem_set !== "undefined") {
        pretn_pretnitem_set.forEach((item,i)=> {
          totalPrice = totalPrice + parseFloat(parseFloat(item.price).toFixed(2))
          totalDiscount = totalDiscount + parseFloat(parseFloat(item.discount_value).toFixed(2))
          totalTax = totalTax + parseFloat(parseFloat(item.igst_amount).toFixed(2))
          total = total + parseFloat(parseFloat(item.total).toFixed(2))
        })
      }

      totalPrice = parseFloat(totalPrice).toFixed(2)
      totalDiscount = parseFloat(totalDiscount).toFixed(2)
      totalTax = parseFloat(totalTax).toFixed(2)
      total = parseFloat(total).toFixed(2)
      this.modifyItemState('totalPrice', totalPrice)
      this.modifyItemState('totalDiscount', totalDiscount)
      this.modifyItemState('totalTax', totalTax)
      this.modifyItemState('total', total)
  }


  handleUpdateItem(item) {
    if(typeof item.discount_value === "undefined") {
      item['discount_value'] = ""
    }

    let pretn = this.state.pretn
    let pretn_pretnitem_set
    if(typeof pretn.pretnitem_set !== "undefined") {
        pretn_pretnitem_set = pretn.pretnitem_set.filter(obj=> obj.tableIndex !== item.tableIndex)
    }

    pretn_pretnitem_set = pretn_pretnitem_set.concat(item)
    this.modifyItemState('pretnitem_set', pretn_pretnitem_set)
    this.handleCalculateTotal(pretn_pretnitem_set)
  }

  handleDeleteItem(item_index){
    let pretn = this.state.pretn
    let pretn_pretnitem_set = []
    if(typeof pretn.pretnitem_set !== "undefined") {
        pretn_pretnitem_set = pretn.pretnitem_set.filter((item,i)=> item.tableIndex !== item_index)

        const reIndexed = pretn_pretnitem_set.map((item,i)=>{
            item['tableIndex'] = i+1
            return item
        })
        this.modifyItemState('pretnitem_set', reIndexed)
        this.setState({pretn_item_tableindex: pretn_pretnitem_set.length})
        this.handleCalculateTotal(pretn_pretnitem_set)
    }

  }

  handleAddItem(item) {
    console.log("em", item);
    let pretn = this.state.pretn
    let pretn_pretnitem_set = []
    if(typeof pretn.pretnitem_set !== "undefined") {
        pretn_pretnitem_set= pretn.pretnitem_set
    }

    pretn_pretnitem_set.push(item)
    this.modifyItemState('pretnitem_set', pretn_pretnitem_set)

  }

  modifyItemState(key, value) {
        let currentPretn = this.state.pretn
        currentPretn[key] = value
        this.setState({
          pretn:currentPretn
       });
  }


  handleSupplierChange(supplier) {
    this.modifyItemState('supplier', supplier)
  }
  handleOutStateChange(outstate) {
    this.modifyItemState('is_igst', outstate)
  }
  handleDateChange(date){
    this.modifyItemState('date', date)
  }

  handleAddRow(event) {
    let tableIndex
    if(typeof this.state.pretn_item_tableindex !== "undefined") {
      tableIndex = this.state.pretn_item_tableindex + 1
    }
    else {
      tableIndex = 1
    }
    const emptyData = {hsn:"", quantity:0, mrp:0, gst:{}, serial:0,
      discount_value:0, purchase_basic_rate:0, basic_purchase_rate:0, purchase_rate:0, price:0, tax:0, total:0, tableIndex:tableIndex,
      cgst_amount:0, sgst_amount:0, igst_amount:0, discount_set:[]}
    this.handleAddItem(emptyData)
    this.setState({pretn_item_tableindex:tableIndex})

  }

  deletePretn() {
    let confirmation = window.confirm('You are about to delete this credit note !')
    if(confirmation) {
      axios({
        url: '/delete_pretn/',
        method: 'post',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          },
          post: {
            'Content-Type': 'multipart/form-data;'
          }
        },
        data: this.state.pretn
      }).then((response)=> {
        if(response.status === 200) {
            NotificationManager.success("Deleted Credit Note successfully")
          setTimeout(()=>{
            this.props.history.push("/debit_notes/")
          }, 700)
        }
      }).catch((err)=> {
        console.log(err);
      })
    }

  }

  submit(e) {
    this.setState({'submitting':true})
    let action = e.target.name;
    let apiurl
    if(this.state.mode ==="edit") {
      apiurl  = "/update_pretn/"
    }
    else {
      apiurl  = "/create_new_pretn/"
    }


    axios({
      url: apiurl,
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.pretn
    }).then((response)=> {
        let responsedRetn = response.data.pretn
      if(response.status === 200) {

        if(this.state.mode === "edit") {
            NotificationManager.success("Updated Credit Note successfully")
        }
        else {
          NotificationManager.success("Created Credit Note successfully")
        }

        if(action === "saveprint") {
          this.props.history.push("/debit_notes/preview/"+responsedRetn.serial+"/?print=true")
        }
        else {
          setTimeout(()=>{
            this.props.history.push("/debit_notes/")
          }, 700)
        }

      }
    }).catch((err)=> {
      console.log(err);
    })
  }



  render() {

      let pretn = this.state.pretn
      console.log(pretn);
      let submitButton = <input type="submit" className="btn btn-success" value="save" onClick={this.submit} />
      let saveAndPrintButton = <input type="submit" name="saveprint" className="btn btn-success" value="Save & Preview" onClick={this.submit} />
      if(this.state.submitting) {
        submitButton = <input type="submit" className="btn btn-success" value="saving.." disabled />
        saveAndPrintButton = <input type="submit" className="btn btn-success" value="Saving.." disabled />
      }

      let supplier = <SupplierElement pretn={pretn} onAddCallback={this.handleSupplierChange} />

      let rowELements = []
      if(typeof pretn.pretnitem_set !== "undefined") {

        pretn.pretnitem_set.sort((a,b)=>{
          return a.tableIndex - b.tableIndex
        })

        rowELements = pretn.pretnitem_set.map((item, i)=>{

          i++
          return <ResponsiveRow pretn={pretn} item={item} rowno={i} key={i} deleteRow={this.handleDeleteItem}
          handleUpdateItem={this.handleUpdateItem}
          handleUpdateQuantity = {this.handleUpdateQuantity}
          handleUpdateBasicRate = {this.handleUpdateBasicRate}
          handleUpdatePurchasePrice = {this.handleUpdatePurchasePrice}
           />
        })
      }



      let pageHeader
      let deletePretnBtn, previewLink
      if(!this.state.loading) {

        if(this.state.mode === "edit") {
          pageHeader = <h3>{"Edit Debit Note  #" + pretn.serial}</h3>
          deletePretnBtn = <button className="btn btn-sm btn-danger" onClick={this.deletePretn}>Delete Credit</button>
          previewLink = <Link to={"/debit_notes/preview/"+this.props.match.params.pretn_id} className="btn btn-primary" > Preview</Link>
        }
        else {
          pageHeader =  <h3>Create New Debit Note</h3>
        }

        return <div className="container-fluid">
          <section className="medium">
                {pageHeader}
                <ul className="list-inline">
                  <li>{previewLink}</li>
                  <li className="pull-right">{deletePretnBtn}</li>
                </ul>

          </section>
            <section className="small">
              <div className="row">
                <div className="col-sm-3">
                  <h4>Supplier</h4>
                  {supplier}
                </div>
                <div className="col-sm-2">
                  <h4>Date</h4>
                  <PretnDate pretn={pretn} handleDateChange={this.handleDateChange} />
                </div>
                <div className="col-sm-2">
                  <h4>Out of State Bill ?</h4>
                  <OutState pretn={pretn}  onChangeCallback={this.handleOutStateChange} />
                </div>
                <div className="col-sm-2">
                  <h4>Supplier Invoice No</h4>
                  <input type="text" className="form-control" value={pretn.supplier_bill_no} onChange={this.handleSupplierBillChange} />
                </div>
              </div>
            </section>
            <section className="small">

            <div className="row">
              <div className="col-sm-12">
                <div className="">
                    <ResonsiveHeader pretn={pretn} />
                    {rowELements}

                    <div className="panel-body">
                    <AddPretnRow handleAddRow={this.handleAddRow}  />
                    </div>

                  <PretnTotal pretn={pretn} />
                </div>

                <div className="text-right">
                  <ul className="list-inline">
                      <li>{submitButton}</li>
                      <li>{saveAndPrintButton}</li>
                  </ul>
                </div>
              </div>
            </div>

            </section>


          </div>

      }
      else {
        return <div>
            <Loader />
        </div>
      }



  }
}



// WEBPACK FOOTER //
// ./src/components/debit/batchdebit.js